<template>
    <b-modal id="ReviewEssay" hide-footer centered title="Revisão">
      <b-overlay :show="loading">
        <div v-if="review">

            <div v-if="!editForm">
                <div class="mb-3">
                    <p>Status</p>
                    
                    <p class="text-info" v-if="review.status === 'draft'">Rascunho</p>
                    <p class="text-success" v-if="review.status === 'finished'">Finalizada</p>
                </div>
    
                <div class="mb-3">
                    <p>Observações</p>
                    <p v-if="observations">
                        {{ observations }}
                    </p>
                    <p v-else class="text-muted">
                        Sem Observações
                    </p>
                </div>
    
                <div v-if="canEdit">
                    <b-button type="button" variant="primary" @click="editForm = true" :disabled="loading">
                        Editar Revisão
                    </b-button>
                </div>
            </div>
    
            <div v-else>
    
                <b-form-group
                    label="Status">
        
                    <!-- Input -->
                    <b-form-select v-model="status" :options="statusOptions"></b-form-select>
                    
                    <has-errors :errors="errors" name="status" />
                </b-form-group>
        
                <b-form-group
                    label="Observações"
                    :description="(255 - parseInt(!observations ? 0 : observations.length)).toString()">
        
                    <!-- Input -->
                    <b-textarea
                        rows="5"
                        v-model="observations"
                        :state="hasErrors('observations', errors)"
                    ></b-textarea>
                    <has-errors :errors="errors" name="observations" />
                </b-form-group>
                <b-form-group>
        
                    <b-button type="button" class="mt-3" variant="primary" @click="handleUpdate" :disabled="loading">
                        Salvar Alteração
                    </b-button>
                    <b-button type="button" class="mt-3" variant="outline" @click="editForm = false" :disabled="loading">
                        Cancelar
                    </b-button>
        
                </b-form-group>
            </div>
        </div>
      </b-overlay>
    </b-modal>
  </template>
  
  <script>
  export default {
        props: {
            edit: {
                type: Boolean,
                default: true,
            }
        },
        data() {
            return {
                canEdit: true,
                loading: false,
                statusOptions: [
                {value: null, text: 'Selecione um status'},
                {value: 'draft', text: 'Rascunho'},
                {value: 'finished', text: 'Finalizada'}
                ],
                status: '',
                observations: '',
                editForm: false,
                errors: {},
                review: null
            }
        },
        created() {
            this.$root.$on('ReviewEssay', (review) => {
                this.review = review;
                this.observations = review.observations;
                if(review?.essay && review.essay.status === "OKAY" || !this.edit){
                    this.canEdit = false;
                }
                //this.status = review.status
                this.$bvModal.show('ReviewEssay')
            })
        },
        watch:{
            
        },  
        methods: {
            handleUpdate(){
                this.loading = true
                axios.put('/teacher/reviews/update', {
                        review_id: this.review.id,
                        status: this.status,
                        observations: this.observations
                }).then((result) => {
                    this.$toast.success(result.data.data.message);
                    this.$emit('updated');
                    window.location.reload();
                    this.errors = {};
                    this.$bvModal.hide('ReviewEssay');
                    
                }).catch((errors) => {
                    this.errors = this.setErrors(errors)
                    this.$toast.error('Erro ao salvar revisão!');
                }).finally(()=> this.loading = false);
            }
        }
  }
  </script>
  
  <style>
  
  </style>